import billRequestApi from '@/api/billRequest/billRequestApi.js';

export default {
	name: 'bill-request-result',
	mixins: [],
	extends: {},
	components: {},
	props: [ 'applyInfo' ],
	data() {
		return {
            selectedMonthsStr:'',
		};
	},
	computed: {
		
	},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		init() {

			if (this.applyInfo.selectedMonths != null) {
				// 按時間由遠到近排序
				this.applyInfo.selectedMonths.sort(function(m1, m2){
					return m1 - m2;
				});
			}

            for (let i in this.applyInfo.selectedMonths) {
                const sm = this.applyInfo.selectedMonths[i];

                let rocYear = parseInt(sm.substring(0, sm.length - 2)) - 1911; // 民國年
                let month = parseInt(sm.substring(sm.length - 2));

                this.selectedMonthsStr += rocYear + '年' + month + '月';

                if (i < this.applyInfo.selectedMonths.length - 1) {
                    this.selectedMonthsStr += ', ';
                }
            }
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/billRequest/billRequestResult.js